var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarksFill(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.086-27v-686.999q0-32.74 23.522-56.261 23.521-23.522 56.262-23.522h463.042q32.507 0 56.363 23.522 23.855 23.521 23.855 56.261v687L410.391-159.652 99.086-26.999ZM781.13-143v-710.781H253.914V-933H781.13q32.741 0 56.262 23.356 23.522 23.356 23.522 55.863V-143H781.13Z"
  })));
}
export default SvgBookmarksFill;